import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {injectIntl, intlShape} from 'react-intl';
import * as FormatUtils from 'utils/formatUtils';
import Tooltip from 'components/common/material/Tooltip';
import IconButton from 'components/common/material/IconButton';
import Payments from 'components/payments/Payments';
import {isPurchaseActive} from './helpers';
import PayoffPayNow from './PayoffPayNow';
import styles from './purchaseSchedule.scss';

const IconButtonTooltip = Tooltip(IconButton);

@injectIntl
@CSSModules(styles)
class PurchaseSechedule extends React.Component {
  static propTypes = {
    intl: intlShape,
    purchase: PropTypes.object.isRequired,
    togglePayNow: PropTypes.func.isRequired,
  };

  renderPaymentScheduleInfo() {
    const {intl: {formatMessage}} = this.props;
    return (
      <IconButtonTooltip tooltipShowOnClick={true} icon="info_outline" tooltip={formatMessage({id: 'purchase.schedule.info.text'})} />
    );
  }

  render() {

    const {purchase, intl:{formatMessage}} = this.props;
    return (
      <div data-at="paymentsScheduleContainer" styleName="purchaseSchedule">
        <div styleName="header">
          <div>
            <span styleName="downPayment">{formatMessage({id: 'purchase.info.label.downPayment'})} {FormatUtils.addPriceSymbol(purchase.downPayment + purchase.sunbitAdditionalDownPayment)}</span>
            <span styleName="paymentDate">{formatMessage({id: 'purchase.info.label.paidOn'})} {FormatUtils.transformDate(purchase.dateTime)}</span>
          </div>
          {this.renderPaymentScheduleInfo()}
        </div>
        <Payments data={purchase.allPaymentsIncludingDownPayment}/>
        {
          isPurchaseActive(purchase) &&
          <div styleName="actions">
            <PayoffPayNow purchase={purchase} cssVariant="inPurchaseSchedule" togglePayNow={this.props.togglePayNow} />
          </div>
        }

      </div>
    );
  }
}

export default PurchaseSechedule;



// WEBPACK FOOTER //
// ./src/purchases/PurchaseSchedule.js